<template>
  <div class="bg-white p-4">
    <div class="mb-8">
      <h2 class="text-2xl font-semibold">Push Notification</h2>

      <div class="flex justify-between items-center gap-4 mt-8">
        <b-input-group class="">
          <b-form-input
            class="border-none shadow-lg"
            type="text"
            min="0.00"
            v-model="search"
            placeholder="Enter Search...."
          ></b-form-input>

          <b-input-group-append>
            <b-button
              variant="white"
              class="flex items-center shadow-lg"
              aria-label="search"
            >
              <feather-icon
                class="cursor-pointer mr-2"
                icon="SearchIcon"
                svgClasses="w-4 h-4"
              ></feather-icon>
            </b-button>
          </b-input-group-append>
        </b-input-group>

        <div>
          <b-button outline v-b-modal.modal-7 variant="primary"
            ><span class="btn-inner--text flex justify-between items-center"
              ><feather-icon icon="PlusIcon" class="cust-HW"></feather-icon
              >Add</span
            ></b-button
          >

          <b-modal id="modal-7" title="Add Push Notification" hide-footer>
            <b-form role="form" @submit.prevent="handleSubmit">
              <div>
                <b-form-group label="Title">
                  <base-input
                    v-model="title"
                    placeholder="Enter Title"
                    name="Title"
                  ></base-input>
                </b-form-group>
                <b-form-group label="Description">
                  <base-input
                    v-model="description"
                    placeholder="Enter Description"
                    name="Description"
                  ></base-input>
                </b-form-group>
                <b-form-group label="Link">
                  <base-input
                    type="url"
                    v-model="link"
                    placeholder="Enter Link Eg:https://www.caregiversaathi.co.in"
                    name="Link"
                  ></base-input>
                </b-form-group>
                <div class="flex gap-2">
                  <div>
                    <label>Date</label>

                    <el-date-picker
                      v-model="selectedDate"
                      type="date"
                      placeholder="Pick a date"
                      :default-value="new Date()"
                      format="dd-MM-yyyy"
                      @input="handleDateInput"
                    >
                    </el-date-picker>
                  </div>
                  <div>
                    <label>Time</label>
                    <!-- <el-time-select
                      v-model="value"
                      :picker-options="{
                        start: '08:30',
                        step: '00:15',
                        end: '18:30',
                      }"
                      placeholder="Select time"
                    >
                    </el-time-select> -->
                    <el-time-picker
                      v-model="selectedTime"
                      arrow-control
                      placeholder="Select time"
                    />
                  </div>
                </div>
                <div class="mt-2">
                  <label>Note:</label>
                  <p>
                    Please be mindful, you won't be able to edit the
                    notification once populated
                  </p>
                </div>
                <div class="flex justify-center mt-2">
                  <b-button type="submit" variant="primary">Submit</b-button>
                </div>
              </div>
            </b-form>
          </b-modal>
        </div>
      </div>
    </div>
    <div>
      <el-table
        border
        :data="tableData"
        style="width: 100%"
        class="mt-4 rounded"
        header-row-class-name="thead-light table-th-color "
      >
        <el-table-column prop="srno" label="Sr. no" width="100">
        </el-table-column>
        <el-table-column prop="date" label="Date" width="100">
        </el-table-column>
        <el-table-column prop="time" label="Time" width="100">
        </el-table-column>
        <el-table-column prop="sent" label="Sent To (Users)" width="140">
        </el-table-column>
        <el-table-column prop="title" label="Title" width=""> </el-table-column>
        <el-table-column prop="desc" label="Description" width="">
        </el-table-column>
        <el-table-column prop="link" label="Link" width=""> </el-table-column>
        <el-table-column
          prop="action"
          label="Action"
          v-slot="{ row }"
          width="100"
        >
          <div class="flex items-center">
            <feather-icon
              svgClasses="w-5 h-5"
              class="ml-2 cursor-pointer text-danger"
              icon="Trash2Icon"
              @click="handleDelete(row)"
            />
          </div>
        </el-table-column>
      </el-table>
      <b-card-footer class="py-4 d-flex justify-content-end">
        <b-pagination
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="perPage"
          aria-controls="my-table"
        ></b-pagination>
      </b-card-footer>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

import _ from "lodash";

import {
  DatePicker,
  TimeSelect,
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown,
  TimePicker,
} from "element-ui";
export default {
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [DatePicker.name]: DatePicker,
    [TimeSelect.name]: TimeSelect,
    [TimePicker.name]: TimePicker,
  },
  data() {
    return {
      // limit:10,
      // offset:0,
      selectedDate: "",
      selectedTime: "",
      search: "",
      totalRows: 0,
      perPage: 10,
      currentPage: 1,
      title: "",
      description: "",
      link: "",
      tableData: [
        // {
        //   date: "2016-05-03",
        //   title: "Tom",
        //   desc: "No. 189, Grove St, Los Angeles",
        // },
        // {
        //   date: "2016-05-02",
        //   title: "Tom",
        //   desc: "No. 189, Grove St, Los Angeles",
        // },
        // {
        //   date: "2016-05-01",
        //   title: "Tom",
        //   desc: "No. 189, Grove St, Los Angeles",
        // },
      ],
    };
  },
  watch: {
    async currentPage() {
      await this.getNotification();
    },
    search: {
      handler: _.debounce(async function (val) {
        this.getNotification();
      }, 500),
    },
  },
  computed: {
    ...mapState("pushNotification", {
      push_notification: "push_notification",
    }),
  },
  methods: {
    formatDate(date) {
      var d = new Date(date),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();

      if (month.length < 2) month = "0" + month;

      if (day.length < 2) day = "0" + day;

      return [day, month, year].join("-");
    },

    formatDate(val) {
      const date = new Date(val);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");

      return `${year}-${month}-${day}`;
    },

    handleDateInput(data) {
      let date = new Date();
      let newDate = new Date(data);
      date = this.formatDate(date);
      newDate = this.formatDate(newDate);

      if (newDate < date) {
        this.selectedDate = "";
        this.errorWithMessage("Please Enter valid date of birth");
      } else {
      }
    },
    errorWithMessage(message) {
      this.$swal({
        // text: "please add title, description, date and Time",
        text: message,
        icon: "warning",
        showCancelButton: false,
        confirmButtonColor: "#830c81",
      });
    },
    async handleSubmit() {
      let payload = {};
      this.title = this.title.trim();
      this.description = this.description.trim();
      this.link = this.link.trim();

      try {
        if (
          this.title === "" ||
          this.description === "" ||
          this.selectedDate === "" ||
          this.selectedTime === ""
        ) {
          await this.$swal({
            // text: "please add title, description, date and Time",
            text: `please enter ${this.title !== "" ? "" : "title, "} ${
              this.description !== "" ? "" : "description, "
            } ${this.selectedDate !== "" ? "" : "Date, "} ${
              this.selectedTime !== "" ? "" : "Time."
            }`,
            icon: "warning",
            showCancelButton: false,
            confirmButtonColor: "#830c81",
          });
          return;
        }

        if (this.title !== "") Object.assign(payload, { title: this.title });
        if (this.description !== "")
          Object.assign(payload, { description: this.description });
        if (this.link !== "") Object.assign(payload, { link: this.link });
        if (this.date !== "")
          Object.assign(payload, { date: this.selectedDate });
        if (this.time !== "")
          Object.assign(payload, { time: this.selectedTime });

        let loader = this.$loading();
        const getNotification = await this.$store.dispatch(
          "pushNotification/createNotification",
          payload
        );
        loader.close();
        // console.log(getNotification);
        if (getNotification.code === 200) {
          this.$bvModal.hide("modal-7");
          await this.$swal({
            text: "Successfully Added Notification in the queue!",
            icon: "success",
            showCancelButton: false,
            confirmButtonColor: "#830c81",
          });
          loader.close();
          this.title = "";
          this.description = "";
          this.link = "";
          this.selectedDate = "";
          this.selectedTime = "";
          await this.getNotification();
        }
      } catch (error) {
        console.log(error);
        loader.close();
      }
    },
    async handleDelete(row) {
      const result = await this.deleteAlert();
      if (result.isConfirmed) {
        this.deleteData(row);
        await this.getNotification();
      }
    },
    deleteAlert() {
      return this.$swal({
        title: "Are you sure?",
        html: `<p class="text-center">You won't be able to revert this!</p>`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#830c81",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      });
    },
    async deleteData(row) {
      let payload = {
        pushNotificationId: row._id,
      };
      // let loader = this.$loading();
      try {
        const data = await this.$store.dispatch(
          "pushNotification/deleteNotification",
          payload
        );
        // loader.close();
        if (data.code == 200) {
          this.getNotification();
          await this.$swal({
            text: "Your notification has been deleted",
            icon: "success",
            showCancelButton: false,
            confirmButtonColor: "#830c81",
          });
        }
      } catch (err) {
        console.log(err);
        loader.close();
      }
    },
    async getNotification() {
      let curPage = this.currentPage - 1;
      let payload = {
        limit: this.perPage,
        offset: curPage,
      };

      if (this.search !== "")
        Object.assign(payload, { search: this.search.trim() });

      let loader = this.$loading();
      try {
        const getNotification = await this.$store.dispatch(
          "pushNotification/getAllNotification",
          payload
        );
        // console.log(getNotification);
        loader.close();
        this.totalRows = this.push_notification.notification.totalCount;
        let notificationdata = this.push_notification.notification.result;
        // console.log(notificationdata);

        const notifications = notificationdata.map((notification, index) => {
          let newDate = this.formatDate(new Date(notification.dateTime));

          let newTime = new Date(notification.dateTime).toLocaleTimeString(
            "en-IN",
            { hour12: false, hour: "2-digit", minute: "2-digit" }
          );

          let isSend = "Pending";

          if (notification && notification.hasOwnProperty("firebaseLog")) {
            isSend = notification.firebaseLog[0].successCount.toString();
          }

          return {
            srno: index + 1 + curPage * this.perPage,
            title: notification.title,
            _id: notification._id,
            desc: notification.description,
            date: newDate,
            time: newTime,
            link: notification.link ? notification.link : "No Link",
            sent: isSend,
          };
        });
        // console.log(notifications);
        this.tableData = notifications;
      } catch (error) {
        console.log(error);
        loader.close();
      }
    },
  },
  async mounted() {
    await this.getNotification();
  },
};
</script>

<style>
.modal-header {
  display: flex !important;
  align-items: center !important;
  background-color: #4f0a4b !important;
  border-color: #4f0a4b !important;
  padding: 10px !important;
}

.modal-title {
  font-size: 20px !important;
  color: #fff !important;
}
.form-group {
  margin-bottom: 0.5rem;
}
</style>
